/**
 * Identity marker for translatable source strings in static data (settings
 * schemas, type registries, menu definitions).
 *
 * The translation extraction CLI recognizes bare `t('...')` calls and adds
 * the string to the catalog. The marker itself does NOT translate — actual
 * translation happens at display time (e.g. via ToolSettingsPanel's
 * `translate` option or `viewer.translationService.t`), so the marked data
 * stays language-independent and safe to define at module scope.
 */
export function t(source: string): string {
  return source;
}
